import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'en',
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'MMMM D',
    LLL: 'MMMM D, YYYY, HH:mm',
    'LLL-Y': 'MMMM D, HH:mm',
    LLLL: 'dddd, MMMM D, YYYY, HH:mm',
    'LLLL-Y': 'dddd, MMMM D, HH:mm',
    l: 'M/D/YYYY',
    'l-Y': 'M/D',
    ll: 'MMM D, YYYY',
    'll-Y': 'MMM D',
    'll-D': 'MMM YYYY',
    lll: 'MMM D, YYYY, h:mm A',
    'lll-Y': 'MMM D, h:mm A',
    llll: 'ddd, MMM D, YYYY, h:mm A',
    'llll-Y': 'ddd, MMM D, h:mm A',
    'll-Y+w': 'ddd, MMM D',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'MMMM D, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%sy ago', other: '%sy ago' },
    M: { one: '%smo ago', other: '%smo ago' },
    w: { one: '%sw ago', other: '%sw ago' },
    d: { one: '%sd ago', other: '%sd ago' },
    h: { one: '%sh ago', other: '%sh ago' },
    m: { one: '%sm ago', other: '%sm ago' },
    s: { one: '%ss ago', other: '%ss ago' },
  },
  future: {
    y: { one: 'in %sy', other: 'in %sy' },
    M: { one: 'in %smo', other: 'in %smo' },
    w: { one: 'in %sw', other: 'in %sw' },
    d: { one: 'in %sd', other: 'in %sd' },
    h: { one: 'in %sh', other: 'in %sh' },
    m: { one: 'in %sm', other: 'in %sm' },
    s: { one: 'in %ss', other: 'in %ss' },
  },
  pastLong: {
    y: { one: '%s year ago', other: '%s years ago' },
    M: { one: '%s month ago', other: '%s months ago' },
    w: { one: '%s week ago', other: '%s weeks ago' },
    d: { one: '%s day ago', other: '%s days ago' },
    h: { one: '%s hour ago', other: '%s hours ago' },
    m: { one: '%s minute ago', other: '%s minutes ago' },
    s: { one: '%s second ago', other: '%s seconds ago' },
  },
  futureLong: {
    y: { one: 'in %s year', other: 'in %s years' },
    M: { one: 'in %s month', other: 'in %s months' },
    w: { one: 'in %s week', other: 'in %s weeks' },
    d: { one: 'in %s day', other: 'in %s days' },
    h: { one: 'in %s hour', other: 'in %s hours' },
    m: { one: 'in %s minute', other: 'in %s minutes' },
    s: { one: 'in %s second', other: 'in %s seconds' },
  },
  abbr: {
    y: { one: '%sy', other: '%sy' },
    M: { one: '%smo', other: '%smo' },
    w: { one: '%sw', other: '%sw' },
    d: { one: '%sd', other: '%sd' },
    h: { one: '%sh', other: '%sh' },
    m: { one: '%sm', other: '%sm' },
    s: { one: '%ss', other: '%ss' },
  },
  full: {
    y: { one: '%s year', other: '%s years' },
    M: { one: '%s month', other: '%s months' },
    w: { one: '%s week', other: '%s weeks' },
    d: { one: '%s day', other: '%s days' },
    h: { one: '%s hour', other: '%s hours' },
    m: { one: '%s minute', other: '%s minutes' },
    s: { one: '%s second', other: '%s seconds' },
  },
  justNow: 'Just now',
  yesterday: 'Yesterday',
  today: 'Today',
  tomorrow: 'Tomorrow',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'h:mm A' },
  timeRangeStyles: {
    yl: { start: 'MMMM D, YYYY', end: 'MMMM D, YYYY' },
    'yl-1': { start: 'MMMM D', end: 'MMMM D, YYYY' },
    ml: { start: 'MMMM D', end: 'MMMM D' },
    'ml-1': { start: 'MMMM D', end: 'D, YYYY' },
    dl: { start: 'MMMM D', end: 'D' },
    y: { start: 'MMM D, YYYY', end: 'MMM D, YYYY' },
    'y-1': { start: 'MMM D', end: 'MMM D, YYYY' },
    m: { start: 'MMM D', end: 'MMM D' },
    'm-1': { start: 'MMM D', end: 'D, YYYY' },
    d: { start: 'MMM D', end: 'D' },
    Y: { start: 'ddd, MMM D, YYYY', end: 'ddd, MMM D, YYYY' },
    'Y-1': { start: 'ddd, MMM D', end: 'ddd, MMM D, YYYY' },
    M: { start: 'ddd, MMM D', end: 'ddd, MMM D' },
    D: { start: 'ddd, MMM D', end: 'ddd, MMM D' },
    yt: { start: 'MMM D, YYYY, HH:mm', end: 'MMM D, YYYY, HH:mm' },
    mt: { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm' },
    dt: { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'MMM D, YYYY, HH:mm', end: 'MMM D, YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'en';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return `[${n}${s[(v - 20) % 10] || s[v] || s[0]}]`;
  },
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
